import React from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/auth-store';
import { ErrorMessage } from '../inputs/error-message';

interface Props {
  redirectUrl?: string;
  emailUsedToReceiveCode?: string;
}

type Input = {
  email: string;
};

export const InitiateResetPasswordForm: React.FC<Props> = ({
  redirectUrl,
  emailUsedToReceiveCode,
}: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<Input>();
  const navigate = useNavigate();
  const { initiatePasswordResetError, initiatePasswordReset } = useAuthStore();

  const onSubmit = async (data: Input) => {
    await initiatePasswordReset({ email: data.email });
    if (redirectUrl) {
      navigate(redirectUrl, {
        state: {
          email: data.email,
        },
      });
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {initiatePasswordResetError && (
        <ErrorMessage>{initiatePasswordResetError}</ErrorMessage>
      )}
      <fieldset className="mt-4">
        <div className="w-full">
          <input
            className="w-full border border-[#a1a1a1] rounded-md p-2"
            type="email"
            id="email"
            placeholder="Email"
            {...register('email', {
              required: 'This field is required.',
            })}
            defaultValue={emailUsedToReceiveCode}
          />
        </div>
        <div>{errors.email && <span>{errors.email.message}</span>}</div>
      </fieldset>
      <fieldset className="flex flex-row mt-6">
        <button
          type="submit"
          disabled={isSubmitting}
          className="bg-red-900 text-white flex-1 hover:bg-[#aaaaaa] shadow-lg p-2 text-lg rounded-lg transition duration-150">
          {/* Update to official spinner later */}
          {isSubmitting ? 'Submitting...' : 'Submit to Send Reset Code'}
        </button>
      </fieldset>
    </form>
  );
};

InitiateResetPasswordForm.defaultProps = {
  redirectUrl: '/auth/change-password',
};
